import { useConnectedClient } from 'context/ConnectedClientContext';

export const useAIRepoAccess = (): boolean => {
  const { details } = useConnectedClient();

  return Boolean(details?.ConnectedTeam?.products?.track_add_ons?.ai_repo);
};
